import { render, staticRenderFns } from "./useragreement.vue?vue&type=template&id=804378b2&scoped=true"
import script from "./useragreement.vue?vue&type=script&lang=js"
export * from "./useragreement.vue?vue&type=script&lang=js"
import style0 from "./useragreement.vue?vue&type=style&index=0&id=804378b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "804378b2",
  null
  
)

export default component.exports